var IndicationPopUpModule = /** @class */ (function () {
    function IndicationPopUpModule() {
    }
    return IndicationPopUpModule;
}());
export { IndicationPopUpModule };
